webpackJsonp([162898551421021],{

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/missed.65a32412.gif";

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _missed = __webpack_require__(465);
	
	var _missed2 = _interopRequireDefault(_missed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage(_ref) {
	  var data = _ref.data,
	      transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    { style: transition && transition.style },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Near Miss. That Page Doesn\'t Exist'
	    ),
	    _react2.default.createElement('img', { src: _missed2.default, alt: 'near miss', className: 'headshot' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You just hit a route that doesn\'t exist... sorry about that.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'home_write_list' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Maybe you are looking for a recent post?'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        data.allMarkdownRemark.edges.map(function (post) {
	          return _react2.default.createElement(
	            'li',
	            { key: post.node.id },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: post.node.frontmatter.path },
	              post.node.frontmatter.title
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = NotFoundPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-18bb5c2f98b393b18a7e.js